import Image from "next/image";
import {
  Marquee,
  MarqueeContent,
  MarqueeFade,
} from "@/components/ui/shadcn-io/marquee";
import { fontSizes } from "@/constants/constants";
import { ButtonCta, LiveChatButton } from "@/components";
const Companies = ({ items, classStyle, title, text, sliderStyle }) => {
  return (
    <div className="flex w-full  ">
      <div
        className={`${classStyle}  flex flex-col items-center justify-center text-center w-full  `}
      >
        {items[0]?.name && (
          <div className="sm:py-12 py-6 px-4">
            <span className="eyebrow flex items-center justify-center gap-3 text-gold-deep mb-3">
              <span className="h-px w-8 bg-gold/70" />
              Selected Work
              <span className="h-px w-8 bg-gold/70" />
            </span>
            <h2 className={`font-display font-semibold text-ink ${fontSizes.text_4_xl}`}>{title}</h2>
            <p className="sm:text-base text-sm text-ink-soft mt-3 max-w-2xl mx-auto">{text}</p>
          </div>
        )}
        <div className="w-full relative overflow-hidden">
          <Marquee>
            <MarqueeContent pauseOnHover className="[--duration:30s] ">
              <div
                className={`flex ${sliderStyle} ${
                  items[0]?.cta && "gap-8 md:gap-20"
                }`}
              >
                {Array.isArray(items) &&
                  items.map((item, index) => (
                    <div
                      key={index}
                      className={`flex justify-center items-center ${
                        items[0]?.name && "flex-col"
                      }`}
                    >
                      <Image
                        className={`${
                          !item.name && "brightness-0 invert bg-contain"
                        }`}
                        src={item?.image}
                        alt={item?.name || "Partner company logo"}
                      />
                      <p className="py-4">{items[0]?.cta && item?.name}</p>
                    </div>
                  ))}
                {items[0]?.cta  && <div className="w-16" />}
              </div>
            </MarqueeContent>

            <MarqueeFade side="left" />
            <MarqueeFade side="right" />
          </Marquee>

          <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background"></div>
        </div>
        {items[0]?.name && items[0]?.cta && (
          <div className="flex gap-4 py-10  ">
            <LiveChatButton
              buttonText="Live Chat"
              classStyle={`text-[#fff] bg-[#1EA7DB] hover:bg-[#1EA7DB]/90 h-12 `}
            />
            <ButtonCta
              buttonText="Get a Quote"
              classStyle={`text-[#fff] bg-[#61C1E5] hover:bg-[#61C1E5]/90 h-12 `}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Companies;
